function Table({ containerCls = "", data = [], columns }) {
  return (
    <div className={`w-full overflow-x-auto text-gray-700`}>
      <table className={`my-6 table-auto w-full text-left ${containerCls}`}>
        <thead>
          <tr>
            {columns.map((col, i) => {
              return (
                <th key={i} className="border border-gray-300 bg-[#E3E9F3] p-3">
                  {col.name}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {data?.map((d, i) => {
            return (
              <tr key={i} className="">
                {columns.map((col, j) => {
                  const Comp = col.renderComp(d, i);

                  return (
                    <td key={j} className="border border-gray-300 p-3">
                      {Comp}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
